"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDateWithTimezoneOffset = exports.isValidDate = exports.doubleDigits = void 0;

var parseDateWithTimezoneOffset = function parseDateWithTimezoneOffset(date) {
  var offset = date.getTimezoneOffset();
  var dateWithTimezoneOffset = new Date(date.getTime() - offset * 60 * 1000);
  return dateWithTimezoneOffset.toISOString();
};

exports.parseDateWithTimezoneOffset = parseDateWithTimezoneOffset;

var isValidDate = function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date);
};
/**
 * Make a time string double digit. So make 9 in to 09.
 *
 * @param {int} number - The number.
 *
 * @returns {int} The double digit number.
 */


exports.isValidDate = isValidDate;

var doubleDigits = function doubleDigits(number) {
  return "0".concat(number).slice(-2);
};

exports.doubleDigits = doubleDigits;